export default "__VITE_ASSET__Fg7czheGUsu8Ypm7sr$dbQ__"